import React, {useEffect} from 'react'

function ShoprocketEventListeners(): React.JSX.Element | null {
  useEffect(() => {
    // Add event listeners when the component mounts
    console.log('waiting for shoprocket_ready')
    window.addEventListener('shoprocket_ready', () => {
      // Listen for cart shipping view
      console.log('shoprocket_ready event fired')

      // Hide tax row
      const hideTaxRow = () => {
        const taxWrapper = document.querySelector(
          '.sr-taxes-wrapper',
        ) as HTMLElement
        if (taxWrapper) taxWrapper.style.display = 'none'
      }

      hideTaxRow()
      ;(window as any).Shoprocket.events.listen('cart.viewed', hideTaxRow)
      ;(window as any).Shoprocket.events.listen('cart.updated', hideTaxRow)
      ;(window as any).Shoprocket.events.listen(
        'cart.checkout_viewed',
        hideTaxRow,
      )
      ;(window as any).Shoprocket.events.listen(
        'cart.payment_viewed',
        hideTaxRow,
      )
      ;(window as any).Shoprocket.events.listen(
        'cart.address_viewed',
        hideTaxRow,
      )
      ;(window as any).Shoprocket.events.listen('cart.address_viewed', () => {
        // Trigger Packeta widget directly when cart.address_viewed is fired
        console.log('cart.address_viewed event fired')

        // Hide address form and show Packeta selection for ALL products
        const selectedPoint = localStorage.getItem('selectedPickupPoint')

        setTimeout(() => {
          const srAddressSection = document.querySelector('.sr-address-section')
          if (!srAddressSection) return

          // Hide address fields except email, name, and phone
          const fieldsToHide = [
            '#sr-shipping-street',
            '#sr-shipping-city',
            '#sr-shipping-postcode',
            '#sr-shipping-country',
            '#sr-shipping-state',
            // '#sr-shipping-phonenumber', // Keep phone visible - mandatory
            '.sr-shipping-billing-same',
            '.sr-address-only-shipping',
            '.sr-address-only-billing',
            '.sr-address-checkbox',
          ]

          fieldsToHide.forEach((selector) => {
            const el = document.querySelector(selector)
            if (el) {
              // Hide the element's wrapper
              const wrapper = el.closest(
                '.sr-floating-wrapper, .sr-shipping-billing-same, .sr-address-only-shipping, .sr-address-only-billing, .sr-address-checkbox, .sr-top',
              )
              if (wrapper) {
                ;(wrapper as HTMLElement).style.display = 'none'
                // Also hide parent .sr-floating-wrapper-50 if all children are hidden
                const parentWrapper = wrapper.closest('.sr-floating-wrapper-50')
                if (parentWrapper) {
                  ;(parentWrapper as HTMLElement).style.display = 'none'
                }
              } else {
                ;(el as HTMLElement).style.display = 'none'
              }
            }
          })

          // Hide title
          const titleEl = document.querySelector('.sr-address-only-shipping')
          if (titleEl) (titleEl as HTMLElement).style.display = 'none'

          // Hide ALL sr-floating-wrapper-50 containers (city/postcode, country/state rows)
          document
            .querySelectorAll('#sr-address-shipping .sr-floating-wrapper-50')
            .forEach((el) => {
              ;(el as HTMLElement).style.display = 'none'
            })

          // Remove any existing packeta UI
          document.getElementById('packeta-ui')?.remove()

          const packetaUI = document.createElement('div')
          packetaUI.id = 'packeta-ui'
          packetaUI.style.cssText = `
            margin: 20px 0;
            padding: 20px;
            background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
            border-radius: 12px;
            border: 2px solid #b8e6dc;
            box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          `

          if (selectedPoint) {
            const point = JSON.parse(selectedPoint)
            packetaUI.innerHTML = `
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 14px;">
                <span style="font-size: 24px;">📦</span>
                <span style="font-weight: 600; color: #233642; font-size: 15px;">Výdajné miesto</span>
                <span style="background: #28a745; color: white; font-size: 11px; padding: 2px 8px; border-radius: 10px; font-weight: 500;">✓ Vybraté</span>
              </div>
              <div style="background: white; padding: 12px 16px; border-radius: 8px; margin-bottom: 14px; border: 1px solid #e0e0e0;">
                <div style="font-weight: 600; color: #233642; margin-bottom: 4px;">${
                  point.name
                }</div>
                <div style="color: #666; font-size: 13px;">${point.city}${
              point.street ? ', ' + point.street : ''
            }</div>
              </div>
              <button id="packeta-change-btn" style="
                padding: 10px 20px;
                background: transparent;
                color: #233642;
                border: 1px solid #233642;
                border-radius: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.2s;
              " onmouseover="this.style.background='#233642';this.style.color='white'" onmouseout="this.style.background='transparent';this.style.color='#233642'">
                Zmeniť miesto
              </button>
            `

            // Fill hidden address fields with Packeta data
            ;(window as any).Shoprocket.cart.address.set('shipping', {
              address: point.street,
              city: point.city,
              postcode: point.zip,
              country: point.country,
              state: point.country?.toLowerCase() === 'cz' ? '761' : '3166',
            })
            ;(window as any).Shoprocket.cart.applyNotes(
              `Packeta #${point.id}: ${point.name}, ${point.city}`,
            )
          } else {
            packetaUI.innerHTML = `
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 14px;">
                <span style="font-size: 24px;">📦</span>
                <span style="font-weight: 600; color: #233642; font-size: 15px;">Kam doručiť?</span>
              </div>
              <p style="color: #666; font-size: 13px; margin: 0 0 16px 0; line-height: 1.5;">
                Vyber si výdajné miesto Packeta blízko teba
              </p>
              <button id="packeta-select-btn" style="
                width: 100%;
                padding: 14px 24px;
                background: #233642;
                color: white;
                border: none;
                border-radius: 8px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 600;
                transition: all 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
              " onmouseover="this.style.background='#1a2830'" onmouseout="this.style.background='#233642'">
                <span>🗺️</span> Vybrať výdajné miesto
              </button>
            `
          }

          // Insert after phone field
          const phoneWrapper = document
            .querySelector('#sr-shipping-phonenumber')
            ?.closest('.sr-floating-wrapper')
          if (phoneWrapper) {
            phoneWrapper.after(packetaUI)
          } else {
            srAddressSection.appendChild(packetaUI)
          }

          // Event listeners
          document
            .getElementById('packeta-select-btn')
            ?.addEventListener('click', () => {
              openPacketaWidget()
            })
          document
            .getElementById('packeta-change-btn')
            ?.addEventListener('click', () => {
              localStorage.removeItem('selectedPickupPoint')
              openPacketaWidget()
            })

          // Auto-open Packeta if not yet selected
          if (!selectedPoint) {
            openPacketaWidget()
          }
        }, 100)
      })

      // Show Packeta info on checkout/payment step
      ;(window as any).Shoprocket.events.listen('cart.checkout_viewed', () => {
        console.log('cart.checkout_viewed event fired')
        showPacketaSummary()
      })
      ;(window as any).Shoprocket.events.listen('cart.payment_viewed', () => {
        console.log('cart.payment_viewed event fired')
        showPacketaSummary()
      })

      function showPacketaSummary() {
        const selectedPoint = localStorage.getItem('selectedPickupPoint')
        if (!selectedPoint) return

        setTimeout(() => {
          // Remove existing summary
          document.getElementById('packeta-summary')?.remove()

          const point = JSON.parse(selectedPoint)
          const summaryEl = document.createElement('div')
          summaryEl.id = 'packeta-summary'
          summaryEl.style.cssText = `
            margin: 12px 0;
            padding: 14px 16px;
            background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
            border-radius: 10px;
            border: 1px solid #b8e6dc;
          `
          summaryEl.innerHTML = `
            <div style="display: flex; align-items: center; gap: 8px;">
              <span style="font-size: 18px;">📦</span>
              <div>
                <div style="font-weight: 600; color: #233642; font-size: 13px;">Doručenie: Packeta</div>
                <div style="color: #666; font-size: 12px;">${point.name}, ${point.city}</div>
              </div>
            </div>
          `

          // Insert before the summary section or T&C
          const tncWrapper = document.querySelector('.sr-tnc-wrapper')
          const summarySection = document.querySelector('.sr-summary')
          if (tncWrapper && !tncWrapper.classList.contains('sr-hide')) {
            tncWrapper.before(summaryEl)
          } else if (summarySection) {
            summarySection.prepend(summaryEl)
          }
        }, 100)
      }
    })

    // Clean up the event listeners when the component unmounts
    return () => {
      window.removeEventListener('shoprocket_ready', () => {})
    }
  }, [])

  function openPacketaWidget() {
    const packetaApiKey = process.env.NEXT_PUBLIC_PACKETA_API_KEY
    const packetaOptions = {
      country: 'cz,sk',
      language: 'sk',
      valueFormat:
        '"Packeta",id,carrierId,carrierPickupPointId,name,city,street',
      defaultPrice: '3.5',
      defaultCurrency: 'EUR',
    }

    function showSelectedPickupPoint(point: any) {
      if (point) {
        console.log('Selected Packeta point:', point)
        localStorage.setItem('selectedPickupPoint', JSON.stringify(point))

        // Fill address fields with Packeta data
        ;(window as any).Shoprocket.cart.address.set('shipping', {
          address: point.street,
          city: point.city,
          postcode: point.zip,
          country: point.country,
          state: point.country.toLowerCase() === 'cz' ? '761' : '3166',
        })
        ;(window as any).Shoprocket.cart.applyNotes(
          `Packeta #${point.id}: ${point.name}, ${point.city}`,
        )

        // Update the Packeta UI directly without toggling cart
        const packetaUI = document.getElementById('packeta-ui')
        if (packetaUI) {
          packetaUI.innerHTML = `
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 14px;">
              <span style="font-size: 24px;">📦</span>
              <span style="font-weight: 600; color: #233642; font-size: 15px;">Výdajné miesto</span>
              <span style="background: #28a745; color: white; font-size: 11px; padding: 2px 8px; border-radius: 10px; font-weight: 500;">✓ Vybraté</span>
            </div>
            <div style="background: white; padding: 12px 16px; border-radius: 8px; margin-bottom: 14px; border: 1px solid #e0e0e0;">
              <div style="font-weight: 600; color: #233642; margin-bottom: 4px;">${
                point.name
              }</div>
              <div style="color: #666; font-size: 13px;">${point.city}${
            point.street ? ', ' + point.street : ''
          }</div>
            </div>
            <button id="packeta-change-btn" style="
              padding: 10px 20px;
              background: transparent;
              color: #233642;
              border: 1px solid #233642;
              border-radius: 6px;
              cursor: pointer;
              font-size: 13px;
              font-weight: 500;
              transition: all 0.2s;
            " onmouseover="this.style.background='#233642';this.style.color='white'" onmouseout="this.style.background='transparent';this.style.color='#233642'">
              Zmeniť miesto
            </button>
          `
          // Re-attach event listener for change button
          document
            .getElementById('packeta-change-btn')
            ?.addEventListener('click', () => {
              localStorage.removeItem('selectedPickupPoint')
              openPacketaWidget()
            })
        }
      }
    }

    ;(window as any).Packeta.Widget.pick(
      packetaApiKey,
      showSelectedPickupPoint,
      packetaOptions,
    )
  }

  return null
}

export default ShoprocketEventListeners
